import React from 'react';
import PropTypes from 'prop-types';
import { Image } from 'components/core/Image';
import { chooseIcon } from './unitIconAssets';

import './unitIcon.scss';

export const chooseIconFile = chooseIcon;

const UnitIcon = (props) => {
	const mappedProps = {
		className: 'unit-icon',
		src: chooseIcon(props.unitSize),
		alt: props.alt,
		lazyLoad: props?.lazyLoad || false,
	};
	return <Image {...mappedProps} />;
};

UnitIcon.propTypes = {
	unitSize: PropTypes.string.isRequired,
	alt: PropTypes.string,
	lazyLoad: PropTypes.bool,
};

export default UnitIcon;
